import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import {
  generateCpf,
  formatCpf,
  generateCnpj,
  formatCnpj,
} from './utils/documentGenerators'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const CpfGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de CPF e CNPJ Online Grátis  jarder.dev',
    description:
      'Gere CPF e CNPJ válidos (dígito verificador correto) ' +
      'instantaneamente, direto no navegador. Grátis, sem cadastro, ideal ' +
      'para testar formulários e sistemas.',
  })

  const [cpf, setCpf] = useState(() => formatCpf(generateCpf()))
  const [cnpj, setCnpj] = useState(() => formatCnpj(generateCnpj()))
  const [copied, setCopied] = useState('')

  const copy = (value, label) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(label)
      trackEvent('tool_copy', { tool: 'cpf_cnpj', doc: label })
      setTimeout(() => setCopied(''), 1500)
    })
  }

  const generate = (doc) => {
    trackEvent('tool_generate', { tool: 'cpf_cnpj', doc })
    if (doc === 'cpf') setCpf(formatCpf(generateCpf()))
    else setCnpj(formatCnpj(generateCnpj()))
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Gerador de CPF e CNPJ</h1>
      <p className="tool-disclaimer">
        Números matematicamente válidos (dígito verificador correto),
        gerados aleatoriamente <strong>apenas para testes de
          desenvolvimento</strong>  não pertencem a nenhuma pessoa ou empresa
        real.
      </p>

      <div className="tool-result-card">
        <span className="tool-result-label">CPF</span>
        <span className="tool-result-value">{cpf}</span>
        <div className="tool-result-actions">
          <button
            type="button"
            className="tool-button tool-button-secondary"
            onClick={() => copy(cpf, 'cpf')}
          >
            Copiar
          </button>
          <button
            type="button"
            className="tool-button"
            onClick={() => generate('cpf')}
          >
            Gerar novo
          </button>
        </div>
        {copied === 'cpf' && <span className="tool-copied">Copiado!</span>}
      </div>

      <div className="tool-result-card">
        <span className="tool-result-label">CNPJ</span>
        <span className="tool-result-value">{cnpj}</span>
        <div className="tool-result-actions">
          <button
            type="button"
            className="tool-button tool-button-secondary"
            onClick={() => copy(cnpj, 'cnpj')}
          >
            Copiar
          </button>
          <button
            type="button"
            className="tool-button"
            onClick={() => generate('cnpj')}
          >
            Gerar novo
          </button>
        </div>
        {copied === 'cnpj' && <span className="tool-copied">Copiado!</span>}
      </div>

      <div className="tool-info-section">
        <h2>Para que serve</h2>
        <p>
          O CPF e o CNPJ têm dígitos verificadores calculados por uma
          fórmula matemática a partir dos números anteriores. Esta
          ferramenta gera números aleatórios que respeitam essa fórmula
          (passam na validação de formulários, sistemas e módulos de
          checkout), mas <strong>não correspondem a nenhuma pessoa física
          ou jurídica cadastrada na Receita Federal</strong>. É voltada
          para desenvolvedores testarem cadastros, integrações e
          formulários sem usar dados reais.
        </p>
      </div>
    </div>
  )
}

export default CpfGenerator
